import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { safeLocalStorage } from '@/shared/lib'
import { DEFAULT_LANGUAGE, LANGUAGE_LOCALE, type Language } from './languages'

type LanguageState = {
  language: Language
  /** Язык выбран вручную: ни Telegram, ни профиль его больше не перебивают. */
  isExplicit: boolean
  /** Ручной выбор в настройках. */
  setLanguage: (language: Language) => void
  /** Язык из `initData` или профиля: применяется, только если человек не выбирал сам. */
  suggestLanguage: (language: Language | null) => void
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      language: DEFAULT_LANGUAGE,
      isExplicit: false,
      setLanguage: (language) => set({ language, isExplicit: true }),
      suggestLanguage: (language) => {
        if (language && !get().isExplicit) {
          set({ language })
        }
      },
    }),
    {
      name: 'tapgift.language',
      storage: createJSONStorage(() => safeLocalStorage),
      // Подсказанный язык не сохраняем: при следующем запуске его снова даст Telegram.
      partialize: (state) => (state.isExplicit ? { language: state.language, isExplicit: true } : {}),
    },
  ),
)

/** Текущий язык вне React — для api-клиента и форматтеров. */
export const getLanguage = (): Language => useLanguageStore.getState().language

useLanguageStore.subscribe((state) => {
  document.documentElement.lang = LANGUAGE_LOCALE[state.language]
})
